export default function () {
  this.sendEvent('subscription.refresh.receipt.ios', {})
}
